import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Voltar ao topo"
      className={`
        fixed bottom-6 right-6 z-50 w-12 h-12 flex items-center justify-center
        rounded-full border-2 cursor-pointer
        transition-all duration-300 ease-out
        ${isVisible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-4 pointer-events-none'
        }
        ${isHovered ? 'scale-110 shadow-lg' : 'scale-100'}
      `}
      style={{
        background: isHovered
          ? 'linear-gradient(135deg, #18c7f4 0%, #384774 100%)'
          : 'linear-gradient(135deg, #384774 0%, #18c7f4 100%)',
        borderColor: 'rgba(24,199,244,0.5)',
      }}
    >
      <i
        className={`ri-arrow-up-line text-white text-xl transition-transform duration-300 ${
          isHovered ? '-translate-y-0.5' : ''
        }`}
      ></i>

      {/* Pulse ring on hover */}
      {isHovered && (
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ background: '#18c7f4' }}
        ></span>
      )}
    </button>
  );
}
